module.exports = __webpack_public_path__ + "static/img/pic25810.940eb9d1.gif";